import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'

interface Option {
  value: string
  label: string
}

interface Props {
  inputsName: string
  value: string
  options: Array<Option>
  onChange: (value: string) => void
}

function FlightsFilterSegmentedControl(props: Props) {
  const { inputsName, value, options, onChange } = props

  return (
    <SegmentedOptionsGroup
      inputsName={inputsName}
      distribution="filled"
      onValueChange={onChange}
    >
      {options.map(option => (
        <SegmentedOption
          key={option.value}
          title={option.label}
          value={option.value}
          checked={value === option.value}
          icon={false}
        />
      ))}
    </SegmentedOptionsGroup>
  )
}

export default FlightsFilterSegmentedControl
